import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import './styles/app.css';
import './styles/management.css';
import './styles/template.css';
import { AppProviders, createQueryClient } from './app/AppContext';
import { redirectLegacyHash, routes } from './app/routes';
import { createAuthAdapter, createDataProvider, createServices } from './services';

const auth = createAuthAdapter();
const services = createServices(createDataProvider(auth));
redirectLegacyHash();
const router = createBrowserRouter(routes);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders services={services} auth={auth} queryClient={createQueryClient()}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
